var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-node-wrapper" },
    [
      _c("fullNodetitle"),
      _vm._v(" "),
      _c("quota-content"),
      _vm._v(" "),
      _c("div", { staticClass: "__second-title" }, [
        _vm._v(_vm._s(_vm.$t("submitStaking")))
      ]),
      _vm._v(" "),
      _c("add-quota"),
      _vm._v(" "),
      _c("div", { staticClass: "__second-title" }, [
        _vm._v(_vm._s(_vm.$t("walletQuota.list.title")))
      ]),
      _vm._v(" "),
      _c("list", { on: { showCancelConfirm: _vm.showCancelConfirm } }),
      _vm._v(" "),
      _c("cancel-stake", { ref: "cancelStakeDom" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }